// import { Box, Divider, Grid, Typography } from "@mui/material";
// import React from "react";
// import productImage from "../../images/Rectangle 6513.png";
// import productImage2 from "../../images/Rectangle 6514.png";
// import productImage3 from "../../images/Rectangle 6515.png";
// import productImage4 from "../../images/Rectangle 6516.png";

// export const ProductDetails: React.FC<any> = React.memo((props) => {
//   return (
//     <>
//       <Grid container spacing={2}>
//         <Grid item xs={12} sm={5}>
//           <img
//             src={productImage}
//             alt="image"
//             style={{ width: "25rem", height: "25rem" }}
//           />
//           <Grid container spacing={2}>
//             <Grid item xs={3}>
//               <img src={productImage2} alt="image" />
//             </Grid>
//             <Grid item xs={3}>
//               <img src={productImage3} alt="image" />
//             </Grid>

//             <Grid item xs={3}>
//               <img src={productImage4} alt="image" />
//             </Grid>
//           </Grid>
//         </Grid>

//         <Grid
//           item
//           xs={12}
//           sm={7}
//           mt={2}
//           sx={{ border: "1px solid #828584", borderRadius: 2 }}
//           p={2}
//         >
//           <Grid container direction="column" spacing={2}>
//             <Grid item>
//               <Box sx={{ border: "1px solid #828584", borderRadius: 2, p: 1 }}>
//                 <Typography fontSize="1rem" fontWeight={700} color="#022219">
//                   Product Name
//                 </Typography>
//                 <Typography variant="caption" color="#828584">
//                   Deconstruct Face Gel Sunscreen SPF 50 + PA+++ | 50 g
//                 </Typography>
//               </Box>
//             </Grid>

//             <Grid item container spacing={2}>
//               <Grid item xs={6}>
//                 <Box
//                   sx={{ border: "1px solid #828584", borderRadius: 2, p: 1 }}
//                 >
//                   <Typography fontSize="1rem" fontWeight={700} color="#022219">
//                     Brand Name
//                   </Typography>
//                   <Typography variant="caption" color="#828584">
//                     Deconstruct
//                   </Typography>
//                 </Box>
//               </Grid>

//               <Grid item xs={6}>
//                 <Box
//                   sx={{ border: "1px solid #828584", borderRadius: 2, p: 1 }}
//                 >
//                   <Typography fontSize="1rem" fontWeight={700} color="#022219">
//                     Category
//                   </Typography>
//                   <Typography variant="caption" color="#828584">
//                     Skin Care
//                   </Typography>
//                 </Box>
//               </Grid>

//               <Grid item xs={6}>
//                 <Box
//                   sx={{ border: "1px solid #828584", borderRadius: 2, p: 1 }}
//                 >
//                   <Typography fontSize="1rem" fontWeight={700} color="#022219">
//                     Manufacturing Company
//                   </Typography>
//                   <Typography variant="caption" color="#828584">
//                     Deconstruct Skincare Labs Pvt. Ltd.
//                   </Typography>
//                 </Box>
//               </Grid>

//               <Grid item xs={6}>
//                 <Box
//                   sx={{ border: "1px solid #828584", borderRadius: 2, p: 1 }}
//                 >
//                   <Typography fontSize="1rem" fontWeight={700} color="#022219">
//                     Batch No.
//                   </Typography>
//                   <Typography variant="caption" color="#828584">
//                     DCGS2406
//                   </Typography>
//                 </Box>
//               </Grid>

//               <Grid item xs={6}>
//                 <Box
//                   sx={{ border: "1px solid #828584", borderRadius: 2, p: 1 }}
//                 >
//                   <Typography fontSize="1rem" fontWeight={700} color="#022219">
//                     Pack Size
//                   </Typography>
//                   <Typography variant="caption" color="#828584">
//                     50gm
//                   </Typography>
//                 </Box>
//               </Grid>

//               <Grid item xs={6}>
//                 <Box
//                   sx={{ border: "1px solid #828584", borderRadius: 2, p: 1 }}
//                 >
//                   <Typography fontSize="1rem" fontWeight={700} color="#022219">
//                     Type
//                   </Typography>
//                   <Typography variant="caption" color="#828584">
//                     Gel
//                   </Typography>
//                 </Box>
//               </Grid>

//               <Grid item xs={6}>
//                 <Box
//                   sx={{ border: "1px solid #828584", borderRadius: 2, p: 1 }}
//                 >
//                   <Typography fontSize="1rem" fontWeight={700} color="#022219">
//                     Stock Quantity
//                   </Typography>
//                   <Typography variant="caption" color="#828584">
//                     50
//                   </Typography>
//                 </Box>
//               </Grid>

//               <Grid item xs={6}>
//                 <Box
//                   sx={{ border: "1px solid #828584", borderRadius: 2, p: 1 }}
//                 >
//                   <Typography fontSize="1rem" fontWeight={700} color="#022219">
//                     Status
//                   </Typography>
//                   <Typography variant="caption" color="#828584">
//                     In Stock
//                   </Typography>
//                 </Box>
//               </Grid>

//               <Grid item xs={6}>
//                 <Box
//                   sx={{ border: "1px solid #828584", borderRadius: 2, p: 1 }}
//                 >
//                   <Typography fontSize="1rem" fontWeight={700} color="#022219">
//                     Cost Price
//                   </Typography>
//                   <Typography variant="caption" color="#828584">
//                     ₹250.00
//                   </Typography>
//                 </Box>
//               </Grid>

//               <Grid item xs={6}>
//                 <Box
//                   sx={{ border: "1px solid #828584", borderRadius: 2, p: 1 }}
//                 >
//                   <Typography fontSize="1rem" fontWeight={700} color="#022219">
//                     Selling Price
//                   </Typography>
//                   <Typography variant="caption" color="#828584">
//                     ₹349.00
//                   </Typography>
//                 </Box>
//               </Grid>

//               <Grid item xs={6}>
//                 <Box
//                   sx={{ border: "1px solid #828584", borderRadius: 2, p: 1 }}
//                 >
//                   <Typography fontSize="1rem" fontWeight={700} color="#022219">
//                     Tax
//                   </Typography>
//                   <Typography variant="caption" color="#828584">
//                     12%
//                   </Typography>
//                 </Box>
//               </Grid>

//               <Grid item xs={6}>
//                 <Box
//                   sx={{ border: "1px solid #828584", borderRadius: 2, p: 1 }}
//                 >
//                   <Typography fontSize="1rem" fontWeight={700} color="#022219">
//                     Discount
//                   </Typography>
//                   <Typography variant="caption" color="#828584">
//                     10%
//                   </Typography>
//                 </Box>
//               </Grid>

//               <Grid item xs={6}>
//                 <Box
//                   sx={{ border: "1px solid #828584", borderRadius: 2, p: 1 }}
//                 >
//                   <Typography fontSize="1rem" fontWeight={700} color="#022219">
//                     Expiry Date
//                   </Typography>
//                   <Typography variant="caption" color="#828584">
//                     15-05-2026
//                   </Typography>
//                 </Box>
//               </Grid>

//               <Grid item xs={12}>
//                 <Box
//                   sx={{ border: "1px solid #828584", borderRadius: 2, p: 1 }}
//                 >
//                   <Typography fontSize="1rem" fontWeight={700} color="#022219">
//                     Description
//                   </Typography>
//                   <Typography variant="caption" color="#828584">
//                     A lightweight gel-based sunscreen offering Broad Spectrum
//                     Protection with SPF 55+ and PA+++.
//                     <br />
//                     * Suitable for all skin types
//                     <br />
//                     * Prevents tanning & sun-related aging
//                     <br />
//                     * Non-oily formula with no white cast
//                     <br />* Water-resistant
//                   </Typography>
//                 </Box>
//               </Grid>
//             </Grid>
//           </Grid>
//         </Grid>
//       </Grid>
//     </>
//   );
// });








import { Box, Grid, Typography } from "@mui/material";
import React, { useState, useEffect, useCallback } from "react";
import { useParams } from "react-router-dom";
import http from "../../commonFunctions/httpClient";
import config from "../../Config/config.json";
import { buildImageUrl } from "../../commonFunctions/CommonFunctions";

interface Product {
  id: string;
  productName: string;
  brandName: string;
  productDescription: string;
  productType: string;
  category?: {
    name: string;
  };
  packSize: string;
  batchNumber: string;
  expiryDate: string;
  manufacturingCompany: string;
  stockQuantity: number;
  stockStatus: string;
  costPrice: number;
  mrp: number;
  sellingPrice: number;
  discountPercentage: number;
  productImageUrl: string;
  thumbnailUrls: string[];
}

export const ProductDetails: React.FC = React.memo(() => {
  const { id } = useParams<{ id: string }>();
  const [product, setProduct] = useState<Product | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  // Image error states
  const [mainImageError, setMainImageError] = useState(false);
  const [thumbErrors, setThumbErrors] = useState<Set<number>>(new Set());

  useEffect(() => {
    const fetchProduct = async () => {
      if (!id) return;

      try {
        setLoading(true);
        setError("");
        const productData = await http.get<Product>(`/pharmacy/products/${id}`);
        setProduct(productData);
        // Reset image errors when new product loads
        setMainImageError(false);
        setThumbErrors(new Set());
      } catch (err: any) {
        setError(err.message || "Failed to fetch product details");
      } finally {
        setLoading(false);
      }
    };

    fetchProduct();
  }, [id]);


  const getImageUrl = useCallback((imagePath: string): string => {
    const finalUrl = buildImageUrl(imagePath, config.imgUrl);
    return finalUrl;
  }, []);


  const mainImageUrl = product ? getImageUrl(product.productImageUrl) : "";
  const thumbnailUrls = product?.thumbnailUrls?.map(getImageUrl) || [];
  console.log("image url",mainImageUrl)

  const handleMainImageError = useCallback(() => {
    setMainImageError(true);
  }, []);

  const handleThumbError = useCallback((index: number) => {
    setThumbErrors(prev => new Set([...prev, index]));
  }, []);

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="400px">
        <Typography>Loading product details...</Typography>
      </Box>
    );
  }

  if (error || !product) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="400px">
        <Typography color="error">{error || "Product not found"}</Typography>
      </Box>
    );
  }

  return (
    <Grid container spacing={2}>
      {/* Left - Images */}
      <Grid item xs={12} sm={5}>
        {/* Main Image */}
        <Box sx={{ mb: 2 }}>
          <Box
            component="img"
            src={mainImageError ? "/fallback-product.png" : mainImageUrl}
            alt={product.productName}
            onError={handleMainImageError}
            sx={{
              width: "25rem",
              height: "25rem",
              objectFit: "cover",
              borderRadius: 2,
              display: 'block',
              maxWidth: '25rem',
              backgroundColor: mainImageError ? "#f5f5f5" : "transparent",
              border: "1px solid #e0e0e0"
            }}
          />
          {mainImageError && (
            <Box sx={{
              mt: 1,
              p: 2,
              border: "2px dashed #e0e0e0",
              borderRadius: 1,
              textAlign: "center",
              backgroundColor: "#fafafa"
            }}>
              <Typography variant="caption" color="textSecondary">
                Image unavailable
              </Typography>
            </Box>
          )}
        </Box>

        {/* Thumbnails */}
        {thumbnailUrls.length > 0 && (
          <Grid container spacing={1}>
            {thumbnailUrls.slice(0, 3).map((thumbUrl, index) => (
              <Grid item xs={4} key={index}>
                <Box
                  component="img"
                  src={thumbErrors.has(index) ? "/fallback-thumb.png" : thumbUrl}
                  alt={`Thumbnail ${index + 1}`}
                  onError={() => handleThumbError(index)}
                  sx={{
                    width: "100%",
                    height: "4rem",
                    objectFit: "cover",
                    borderRadius: 1,
                    border: "1px solid #e0e0e0",
                    cursor: "pointer",
                    display: 'block',
                    backgroundColor: thumbErrors.has(index) ? "#f5f5f5" : "transparent",
                    "&:hover": {
                      borderColor: "#1976d2",
                      borderWidth: 2
                    }
                  }}
                />
              </Grid>
            ))}
          </Grid>
        )}
      </Grid>

      {/* Right - Product Details (unchanged) */}
      <Grid item xs={12} sm={7} sx={{ border: "1px solid #828584", borderRadius: 2, p: 2 }}>
        <Grid container direction="column" spacing={2}>
          <Grid item>
            <Box sx={{ border: "1px solid #828584", borderRadius: 2, p: 1 }}>
              <Typography fontSize="1rem" fontWeight={700} color="#022219">
                Product Name
              </Typography>
              <Typography variant="caption" color="#828584">
                {product.productName}
              </Typography>
            </Box>
          </Grid>

          <Grid item container spacing={2}>
            <Grid item xs={6}>
              <Box sx={{ border: "1px solid #828584", borderRadius: 2, p: 1 }}>
                <Typography fontSize="1rem" fontWeight={700} color="#022219">
                  Brand Name
                </Typography>
                <Typography variant="caption" color="#828584">
                  {product.brandName}
                </Typography>
              </Box>
            </Grid>

            <Grid item xs={6}>
              <Box sx={{ border: "1px solid #828584", borderRadius: 2, p: 1 }}>
                <Typography fontSize="1rem" fontWeight={700} color="#022219">
                  Category
                </Typography>
                <Typography variant="caption" color="#828584">
                  {product.category?.name || "N/A"}
                </Typography>
              </Box>
            </Grid>

            <Grid item xs={6}>
              <Box sx={{ border: "1px solid #828584", borderRadius: 2, p: 1 }}>
                <Typography fontSize="1rem" fontWeight={700} color="#022219">
                  Manufacturing Company
                </Typography>
                <Typography variant="caption" color="#828584">
                  {product.manufacturingCompany}
                </Typography>
              </Box>
            </Grid>

            <Grid item xs={6}>
              <Box sx={{ border: "1px solid #828584", borderRadius: 2, p: 1 }}>
                <Typography fontSize="1rem" fontWeight={700} color="#022219">
                  Batch No.
                </Typography>
                <Typography variant="caption" color="#828584">
                  {product.batchNumber}
                </Typography>
              </Box>
            </Grid>

            <Grid item xs={6}>
              <Box sx={{ border: "1px solid #828584", borderRadius: 2, p: 1 }}>
                <Typography fontSize="1rem" fontWeight={700} color="#022219">
                  Pack Size
                </Typography>
                <Typography variant="caption" color="#828584">
                  {product.packSize}
                </Typography>
              </Box>
            </Grid>

            <Grid item xs={6}>
              <Box sx={{ border: "1px solid #828584", borderRadius: 2, p: 1 }}>
                <Typography fontSize="1rem" fontWeight={700} color="#022219">
                  Type
                </Typography>
                <Typography variant="caption" color="#828584">
                  {product.productType}
                </Typography>
              </Box>
            </Grid>

            <Grid item xs={6}>
              <Box sx={{ border: "1px solid #828584", borderRadius: 2, p: 1 }}>
                <Typography fontSize="1rem" fontWeight={700} color="#022219">
                  Stock Quantity
                </Typography>
                <Typography variant="caption" color="#828584">
                  {product.stockQuantity}
                </Typography>
              </Box>
            </Grid>

            <Grid item xs={6}>
              <Box sx={{ border: "1px solid #828584", borderRadius: 2, p: 1 }}>
                <Typography fontSize="1rem" fontWeight={700} color="#022219">
                  Status
                </Typography>
                <Typography variant="caption" color="#828584">
                  {product.stockStatus === "0" ? "In Stock" :
                    product.stockStatus === "1" ? "Out Of Stock" :
                      product.stockStatus === "2" ? "Limited Stock" : product.stockStatus}
                </Typography>
              </Box>
            </Grid>

            <Grid item xs={6}>
              <Box sx={{ border: "1px solid #828584", borderRadius: 2, p: 1 }}>
                <Typography fontSize="1rem" fontWeight={700} color="#022219">
                  Cost Price
                </Typography>
                <Typography variant="caption" color="#828584">
                  ₹{product.costPrice.toLocaleString()}
                </Typography>
              </Box>
            </Grid>

            <Grid item xs={6}>
              <Box sx={{ border: "1px solid #828584", borderRadius: 2, p: 1 }}>
                <Typography fontSize="1rem" fontWeight={700} color="#022219">
                  MRP
                </Typography>
                <Typography variant="caption" color="#828584">
                  ₹{product.mrp.toLocaleString()}
                </Typography>
              </Box>
            </Grid>

            <Grid item xs={6}>
              <Box sx={{ border: "1px solid #828584", borderRadius: 2, p: 1 }}>
                <Typography fontSize="1rem" fontWeight={700} color="#022219">
                  Selling Price
                </Typography>
                <Typography variant="caption" color="#828584">
                  ₹{product.sellingPrice.toLocaleString()}
                </Typography>
              </Box>
            </Grid>

            <Grid item xs={6}>
              <Box sx={{ border: "1px solid #828584", borderRadius: 2, p: 1 }}>
                <Typography fontSize="1rem" fontWeight={700} color="#022219">
                  Discount
                </Typography>
                <Typography variant="caption" color="#828584">
                  {product.discountPercentage}%
                </Typography>
              </Box>
            </Grid>

            <Grid item xs={6}>
              <Box sx={{ border: "1px solid #828584", borderRadius: 2, p: 1 }}>
                <Typography fontSize="1rem" fontWeight={700} color="#022219">
                  Expiry Date
                </Typography>
                <Typography variant="caption" color="#828584">
                  {new Date(product.expiryDate).toLocaleDateString('en-IN')}
                </Typography>
              </Box>
            </Grid>

            <Grid item xs={12}>
              <Box sx={{ border: "1px solid #828584", borderRadius: 2, p: 1 }}>
                <Typography fontSize="1rem" fontWeight={700} color="#022219">
                  Description
                </Typography>
                <Typography variant="caption" color="#828584">
                  {product.productDescription}
                </Typography>
              </Box>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
});
